// extracted by mini-css-extract-plugin
export default {"ProductSizeControl":"ProductSizeControl_ProductSizeControl__nw2ta","label":"ProductSizeControl_label__z7-PY"};